(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-lake"]) return;
  try {
    
  (function () {
    'use strict';

    var API_BASE = 'https://api.welakeyou.com';
    var sectionEl = document.getElementById('new-lake-section');
    var CATALOG_URL = (sectionEl && sectionEl.getAttribute('data-catalog-url')) || '';
    var EMAIL_KEY = 'wly-lake-email';

    var resultEl = document.getElementById('new-lake-result');
    var productsWrap = document.getElementById('new-lake-products-wrap');
    var productsEl = document.getElementById('new-lake-products');
    var productsLede = document.getElementById('new-lake-products-lede');
    var searchInput = document.getElementById('new-lake-search');
    var searchResults = document.getElementById('new-lake-search-results');
    var requestAnyBtn = document.getElementById('new-lake-request-any');
    var dialog = document.getElementById('new-lake-dialog');
    var dialogContent = document.getElementById('new-lake-dialog-content');

    var lake = null; // {id3dhp, name, state, county, coords, supported}
    var selected = null; // last autocomplete selection, used as a fallback
    var typedName = '';
    var mockupSource = null;
    var mockupProducts = {};
    var dialogContext = null;

    var catalogPromise = (window.WlyLakeCatalog)
      ? window.WlyLakeCatalog.load(CATALOG_URL)
      : Promise.resolve([]);

    // ---------- small helpers ----------
    function h(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined && text !== null) node.textContent = text;
      return node;
    }

    function lakeLabel() {
      return (lake && lake.name) || typedName || 'your lake';
    }

    function formValue(form, name) {
      var field = form.elements.namedItem(name);
      return field ? String(field.value || '').trim() : '';
    }

    function isEmail(value) {
      return /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(value);
    }

    function focusSearch() {
      clearResult();
      searchInput.focus();
      searchInput.select();
    }

    function clearResult() {
      resultEl.innerHTML = '';
      productsWrap.hidden = true;
      productsEl.innerHTML = '';
      closeMockups();
    }

    function imageUrl(src) {
      if (!src) return '';
      return /^https?:\/\//i.test(src) ? src : API_BASE + '/' + String(src).replace(/^\/+/, '');
    }

    function pickArtwork(payload) {
      var images = payload && payload.images;
      if (!images) return '';
      if (!Array.isArray(images)) return images.waves || images.blue || Object.values(images)[0] || '';
      return images[0] || '';
    }

    function acresLabel(areaSqKm) {
      var acres = Number(areaSqKm) * 247.105;
      if (!isFinite(acres) || acres < 1) return '';
      return Math.round(acres).toLocaleString() + ' acres';
    }

    // ---------- result rendering ----------
    function renderLoading(message) {
      clearResult();
      var box = h('div', 'new-lake-loading');
      box.appendChild(h('span', 'new-lake-spinner'));
      box.appendChild(h('span', null, message || 'Drawing your lake…'));
      resultEl.appendChild(box);
    }

    function renderError(message) {
      clearResult();
      var box = h('div', 'new-lake-error');
      box.appendChild(h('p', null, message));
      var retry = h('button', 'new-lake-link-btn', 'Request this lake instead');
      retry.type = 'button';
      retry.addEventListener('click', function () {
        typedName = searchInput.value.trim();
        lake = null;
        openDialog('request');
      });
      box.appendChild(retry);
      resultEl.appendChild(box);
    }

    function metaLine(payload) {
      var parts = [];
      var location = [lake.county, lake.state].filter(Boolean).join(', ');
      if (location) parts.push(location);
      var acres = acresLabel(payload && payload.areasqkm);
      if (acres) parts.push(acres);
      if (lake.coords) parts.push(lake.coords);
      return parts;
    }

    function heroArt(payload) {
      var art = h('div', 'new-lake-hero-art');
      var src = imageUrl(pickArtwork(payload));
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = (lake.name ? lake.name + ' ' : 'Lake ') + 'outline artwork';
        img.loading = 'eager';
        art.appendChild(img);
      }
      return art;
    }

    function renderHero(payload) {
      clearResult();

      var supported = lake.supported;
      var hero = h('div', 'new-lake-hero' + (supported ? '' : ' new-lake-hero--unsupported'));
      hero.appendChild(heroArt(payload));

      var body = h('div', 'new-lake-hero-body');

      if (supported) {
        body.appendChild(h('p', 'new-lake-hero-eyebrow', 'Your lake, our art'));
        body.appendChild(h('h3', 'new-lake-hero-title', 'This is what we think ' + lake.name + ' looks like'));
        body.appendChild(
          h('p', 'new-lake-hero-lede', 'Drawn from real shoreline data.')
        );
      } else {
        body.appendChild(h('p', 'new-lake-hero-eyebrow', 'Not available yet'));
        body.appendChild(h('h3', 'new-lake-hero-title', "We can't make this one just yet."));
        body.appendChild(
          h(
            'p',
            'new-lake-hero-lede',
            "This lake doesn't have a name we can use, so we can't build a collection for it yet. Want us to look into it? Leave your email and we'll let you know if that changes."
          )
        );
      }

      var parts = metaLine(payload);
      if (parts.length) {
        var meta = h('p', 'new-lake-hero-meta');
        parts.forEach(function (part) {
          meta.appendChild(h('span', 'new-lake-meta-part', part));
        });
        body.appendChild(meta);
      }

      var actions = h('div', 'new-lake-hero-actions');
      var requestBtn = h('button', 'new-lake-btn-primary', supported ? 'Request this lake' : 'Request it anyway');
      requestBtn.type = 'button';
      requestBtn.addEventListener('click', function () {
        openDialog('request');
      });
      actions.appendChild(requestBtn);

      if (supported) {
        var issueBtn = h('button', 'new-lake-btn-ghost', 'Something look off?');
        issueBtn.type = 'button';
        issueBtn.addEventListener('click', function () {
          openDialog('issue');
        });
        actions.appendChild(issueBtn);
      }

      body.appendChild(actions);
      hero.appendChild(body);
      resultEl.appendChild(hero);

      if (supported) {
        productsLede.textContent =
          "A preview of what a " + lake.name + " collection could include. Nothing here is for sale yet — but tell us if you want it.";
      }
    }

    // ---------- mockup previews ----------
    function closeMockups() {
      if (mockupSource) {
        mockupSource.close();
        mockupSource = null;
      }
      mockupProducts = {};
    }

    function stopMockups() {
      if (mockupSource) {
        mockupSource.close();
        mockupSource = null;
      }
      if (!Object.keys(mockupProducts).length) {
        productsEl.innerHTML = '';
        productsWrap.hidden = true;
      }
    }

    function startMockups(sseUrl) {
      closeMockups();
      productsEl.innerHTML = '';
      productsWrap.hidden = false;

      var url = /^https?:\/\//i.test(sseUrl) ? sseUrl : API_BASE + '/' + String(sseUrl).replace(/^\/+/, '');
      mockupSource = new EventSource(url);

      mockupSource.addEventListener('message', function (event) {
        var data;
        try {
          data = JSON.parse(event.data);
        } catch (error) {
          return;
        }
        handleMockupEvent(data);
      });

      mockupSource.addEventListener('error', function () {
        stopMockups();
      });
    }

    function handleMockupEvent(data) {
      if (data.type === 'products_loaded') {
        (data.products || []).forEach(function (product) {
          mockupProducts[product.printful_template_id] = {
            templateId: product.printful_template_id,
            title: product.title,
            status: 'loading',
            imageUrl: ''
          };
        });
        renderProducts();
      } else if (data.type === 'mockup_complete') {
        var product = mockupProducts[data.template_id];
        if (!product) return;
        product.status = 'ready';
        product.imageUrl = (data.images && data.images[0] && data.images[0].url) || '';
        renderProducts();
      } else if (data.type === 'mockup_error') {
        delete mockupProducts[data.template_id];
        renderProducts();
      } else if (data.type === 'complete') {
        closeMockups();
      } else if (data.type === 'error') {
        stopMockups();
      }
    }

    function renderProducts() {
      productsEl.innerHTML = '';
      var items = Object.keys(mockupProducts).map(function (key) {
        return mockupProducts[key];
      });

      if (!items.length) {
        productsWrap.hidden = true;
        return;
      }

      productsWrap.hidden = false;
      items.forEach(function (product) {
        var card = h('article', 'new-lake-product-card');
        var imageWrap = h('div', 'new-lake-product-image-wrap');

        if (product.status === 'ready' && product.imageUrl) {
          var img = document.createElement('img');
          img.src = product.imageUrl;
          img.alt = product.title || 'Product preview';
          img.loading = 'lazy';
          imageWrap.appendChild(img);
        } else {
          imageWrap.appendChild(h('span', 'new-lake-product-loading', 'Printing a preview…'));
        }

        var body = h('div', 'new-lake-product-body');
        body.appendChild(h('h4', 'new-lake-product-title', product.title));

        var button = h('button', 'new-lake-product-btn', 'Request Now');
        button.type = 'button';
        button.addEventListener('click', function () {
          openDialog('request');
        });
        body.appendChild(button);

        card.appendChild(imageWrap);
        card.appendChild(body);
        productsEl.appendChild(card);
      });
    }

    // ---------- generate base art ----------
    function applyLake(payload) {
      var name = (payload.lake_name || payload.wly_lake_name || payload.gnisidlabel || '').trim();
      if (!name && selected && selected.name) name = selected.name;

      lake = {
        id3dhp: payload.id3dhp || '',
        name: name,
        state: (payload.state_name || (selected && selected.state) || '').trim(),
        county: (payload.county_name || (selected && selected.county) || '').trim(),
        coords: (payload.coords || (selected && selected.coords) || '').trim(),
        supported: !!name
      };
      typedName = '';
    }

    function generateFromPayload(payload) {
      renderLoading();
      closeMockups();
      productsWrap.hidden = true;

      fetch(API_BASE + '/api/generate_base_art', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            renderError('We could not generate artwork for that lake. ' + (result.body.error || ''));
            return;
          }
          applyLake(result.body);
          renderHero(result.body);
          if (result.body.mockup_sse_url && lake.supported) {
            startMockups(result.body.mockup_sse_url);
          }
        })
        .catch(function (error) {
          console.error('Base art request failed:', error);
          renderError('Something went wrong while drawing your lake. Please try again.');
        });
    }

    // ---------- lake search ----------
    var searchTimer = null;
    var searchController = null;

    function catalogExactMatch(result) {
      if (!window.WlyLakeCatalog) return null;
      var matches = window.WlyLakeCatalog.exactMatches(result.name, result.state_name, result.county_name);
      return matches.length === 1 ? matches[0] : null;
    }

    function hideSearchResults() {
      searchResults.classList.remove('is-open');
      searchResults.innerHTML = '';
      searchInput.setAttribute('aria-expanded', 'false');
    }

    function showSearchResults() {
      searchResults.classList.add('is-open');
      searchInput.setAttribute('aria-expanded', 'true');
    }

    function selectLake(result) {
      selected = {
        name: result.name,
        state: result.state_name || '',
        county: result.county_name || '',
        coords: ''
      };
      lake = null;
      typedName = '';
      searchInput.value = result.name;
      hideSearchResults();

      var payload = { id3dhp: result.id3dhp };
      if (result.centroid_lat && result.centroid_lon) {
        payload.centroid_lat = Number(result.centroid_lat);
        payload.centroid_lon = Number(result.centroid_lon);
      }
      generateFromPayload(payload);
    }

    function renderSearchRows(results) {
      searchResults.innerHTML = '';

      if (!results.length) {
        var empty = h('div', 'new-lake-search-empty', 'No lake found for “' + searchInput.value.trim() + '”.');
        var request = h('button', 'new-lake-link-btn', 'Request it');
        request.type = 'button';
        request.addEventListener('click', requestTypedLake);
        empty.appendChild(document.createTextNode(' '));
        empty.appendChild(request);
        searchResults.appendChild(empty);
        showSearchResults();
        return;
      }

      results.forEach(function (result) {
        var exact = catalogExactMatch(result);
        var row = h('button', 'new-lake-result-item');
        row.type = 'button';
        row.setAttribute('role', 'option');

        var main = h('span', 'new-lake-result-main');
        main.appendChild(h('strong', null, result.name));

        var location = [result.county_name, result.state_name].filter(Boolean).join(', ');
        var area = result.area_sqkm ? ' · ' + Number(result.area_sqkm).toLocaleString() + ' sq km' : '';
        main.appendChild(h('span', 'new-lake-result-location', location + area));
        row.appendChild(main);

        if (exact) {
          row.appendChild(h('span', 'new-lake-badge', 'In the shop'));
        }
        row.appendChild(h('span', 'new-lake-result-arrow', '→'));

        row.addEventListener('click', function () {
          if (exact) {
            window.location.href = window.WlyLakeCatalog.collectionUrl(exact);
            return;
          }
          selectLake(result);
        });

        searchResults.appendChild(row);
      });

      showSearchResults();
    }

    function performSearch(query) {
      if (searchController) searchController.abort();
      searchController = new AbortController();

      fetch(API_BASE + '/api/lake-search?q=' + encodeURIComponent(query), {
        signal: searchController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (body) {
          renderSearchRows(body.results || []);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          renderSearchRows([]);
        });
    }

    searchInput.addEventListener('input', function () {
      var query = this.value.trim();
      if (searchTimer) clearTimeout(searchTimer);

      if (query.length < 2) {
        hideSearchResults();
        return;
      }

      searchTimer = setTimeout(function () {
        performSearch(query);
      }, 300);
    });

    document.addEventListener('click', function (event) {
      if (event.target !== searchInput && !searchResults.contains(event.target)) {
        hideSearchResults();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hideSearchResults();
    });

    // ---------- request / feedback dialog ----------
    function setDialogLabel(text) {
      dialog.setAttribute('aria-label', text);
    }

    function requestTypedLake() {
      var query = searchInput.value.trim();
      if (!query) {
        searchInput.focus();
        return;
      }
      typedName = query;
      lake = null;
      hideSearchResults();
      openDialog('request');
    }

    requestAnyBtn.addEventListener('click', requestTypedLake);

    function candidateList(matches) {
      var list = h('div', 'new-lake-candidates');
      matches.forEach(function (match) {
        var entry = match.entry;
        var row = h('div', 'new-lake-candidate');
        row.appendChild(h('span', null, entry.term));
        var link = document.createElement('a');
        link.href = window.WlyLakeCatalog.collectionUrl(entry);
        link.textContent = 'Shop →';
        row.appendChild(link);
        list.appendChild(row);
      });
      return list;
    }

    function renderExisting(entry) {
      dialogContent.innerHTML = '';
      setDialogLabel('Already in the shop');
      dialogContent.appendChild(h('p', 'new-lake-eyebrow', 'Good news'));
      dialogContent.appendChild(h('h3', null, entry.name + ' is already in the shop.'));

      var copy = h('p', null, "Nothing to request — go take a look. If it's not the right lake, search again.");
      dialogContent.appendChild(copy);

      var list = h('div', 'new-lake-candidates');
      var row = h('div', 'new-lake-candidate');
      row.appendChild(h('span', null, entry.term));
      var link = document.createElement('a');
      link.href = window.WlyLakeCatalog.collectionUrl(entry);
      link.textContent = 'Shop →';
      row.appendChild(link);
      list.appendChild(row);
      dialogContent.appendChild(list);

      var again = h('button', 'new-lake-link-btn', 'Search again');
      again.type = 'button';
      again.addEventListener('click', function () {
        dialog.close();
        focusSearch();
      });
      dialogContent.appendChild(again);
    }

    function renderPossible(matches, mode) {
      dialogContent.innerHTML = '';
      setDialogLabel('Is this the lake you mean?');
      dialogContent.appendChild(h('h3', null, 'Is this the same lake?'));
      dialogContent.appendChild(
        h('p', null, "We already have a lake or two that might be this one. If it's a match, shop it below.")
      );
      dialogContent.appendChild(candidateList(matches));

      var callToAction = h('p', null, "None of these? ");
      var requestBtn = h('button', 'new-lake-link-btn', "This isn't my lake — request mine");
      requestBtn.type = 'button';
      requestBtn.addEventListener('click', function () {
        renderForm(mode);
      });
      callToAction.appendChild(requestBtn);
      dialogContent.appendChild(callToAction);
    }

    function emailValue() {
      try {
        return window.localStorage.getItem(EMAIL_KEY) || '';
      } catch (error) {
        return '';
      }
    }

    function rememberEmail(email) {
      try {
        window.localStorage.setItem(EMAIL_KEY, email);
      } catch (error) {
        /* private mode: ignore */
      }
    }

    function field(labelText, input, optional) {
      var wrapper = document.createElement('label');
      wrapper.className = 'new-lake-field';
      var label = h('span', null, labelText);
      if (optional) label.appendChild(h('span', 'new-lake-optional', ' (optional)'));
      wrapper.appendChild(label);
      wrapper.appendChild(input);
      return wrapper;
    }

    function renderForm(mode) {
      dialogContent.innerHTML = '';
      var isIssue = mode === 'issue';
      var label = lakeLabel();
      var hasLakeName = !!(lake && lake.name);
      var hasRequestName = hasLakeName || !!typedName;
      var requestTitle = hasRequestName ? 'Request ' + label : 'Request this lake';
      setDialogLabel(isIssue ? 'Report a problem' : 'Request this lake');

      dialogContent.appendChild(h('h3', null, isIssue ? 'Something look off?' : requestTitle));
      dialogContent.appendChild(
        h(
          'p',
          null,
          isIssue
            ? "Tell us what's wrong and we'll take another look at " + label + '.'
            : "We'll email you when it's in the shop — usually within a day or two."
        )
      );

      var form = document.createElement('form');
      form.setAttribute('novalidate', 'novalidate');

      // Honeypot: hidden from people, irresistible to naive bots.
      var honeypot = document.createElement('input');
      honeypot.type = 'text';
      honeypot.name = 'website';
      honeypot.className = 'new-lake-hp';
      honeypot.tabIndex = -1;
      honeypot.autocomplete = 'off';
      honeypot.setAttribute('aria-hidden', 'true');
      form.appendChild(honeypot);

      if (isIssue) {
        var chips = document.createElement('fieldset');
        chips.className = 'new-lake-chips';
        chips.appendChild(h('legend', null, "What's the problem?"));
        [
          ['wrong_lake', 'Wrong lake'],
          ['artwork_wrong', 'Artwork looks wrong'],
          ['something_else', 'Something else']
        ].forEach(function (option, index) {
          var chip = document.createElement('label');
          chip.className = 'new-lake-chip';
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'reason';
          input.value = option[0];
          if (index === 0) input.checked = true;
          chip.appendChild(input);
          chip.appendChild(h('span', null, option[1]));
          chips.appendChild(chip);
        });
        form.appendChild(chips);
      }

      var email = document.createElement('input');
      email.type = 'email';
      email.name = 'email';
      email.autocomplete = 'email';
      email.required = true;
      email.placeholder = 'you@example.com';
      email.value = emailValue();
      form.appendChild(field('Email', email));

      var message;
      if (isIssue) {
        message = document.createElement('textarea');
        message.rows = 3;
        message.placeholder = 'What did you expect to see?';
      } else {
        message = document.createElement('input');
        message.type = 'text';
        message.placeholder = "e.g. I'd love it on a hoodie";
      }
      message.name = 'message';
      message.maxLength = 2000;
      form.appendChild(field(isIssue ? 'Details' : 'Anything else?', message, !isIssue));

      var errorBox = h('p', 'new-lake-form-error');
      errorBox.hidden = true;
      form.appendChild(errorBox);

      var submit = h('button', 'new-lake-submit', isIssue ? 'Send feedback' : (hasRequestName ? 'Request ' + label : 'Send request'));
      submit.type = 'submit';
      form.appendChild(submit);

      if (!isIssue) {
        form.appendChild(h('p', 'new-lake-micro', 'Just this one email. No newsletter.'));
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitForm(form, mode, submit, errorBox);
      });

      if (isIssue) {
        var details = form.elements.namedItem('message');
        var reasonInputs = form.querySelectorAll('input[name="reason"]');
        var syncDetails = function () {
          var reason = form.querySelector('input[name="reason"]:checked');
          var required = !reason || reason.value === 'something_else';
          details.required = required;
          details.placeholder = required ? 'Tell us a little more…' : 'Anything else we should know? (optional)';
        };
        reasonInputs.forEach(function (input) {
          input.addEventListener('change', syncDetails);
        });
        syncDetails();
      }

      dialogContent.appendChild(form);

      if (isIssue) {
        var switchBack = h('p', 'new-lake-switch');
        switchBack.appendChild(document.createTextNode('Actually, just request this lake. '));
        var back = h('button', 'new-lake-link-btn', 'Request it');
        back.type = 'button';
        back.addEventListener('click', function () {
          renderForm('request');
        });
        switchBack.appendChild(back);
        dialogContent.appendChild(switchBack);
      } else if (hasLakeName) {
        var switchToIssue = h('p', 'new-lake-switch');
        switchToIssue.appendChild(document.createTextNode('Something look off with this lake? '));
        var issueLink = h('button', 'new-lake-link-btn', 'Tell us');
        issueLink.type = 'button';
        issueLink.addEventListener('click', function () {
          renderForm('issue');
        });
        switchToIssue.appendChild(issueLink);
        dialogContent.appendChild(switchToIssue);
      }

      var first = form.querySelector('input[type="email"]');
      if (first) setTimeout(function () { first.focus(); }, 60);
    }

    function submitForm(form, mode, submit, errorBox) {
      var email = formValue(form, 'email');
      var message = formValue(form, 'message');
      var reason = formValue(form, 'reason');

      if (!isEmail(email)) {
        errorBox.textContent = 'Please enter a valid email address.';
        errorBox.hidden = false;
        return;
      }

      if (mode === 'issue' && (!reason || (reason === 'something_else' && !message))) {
        errorBox.textContent = reason ? 'Please tell us a little about the problem.' : 'Please choose what went wrong.';
        errorBox.hidden = false;
        return;
      }

      errorBox.hidden = true;
      var originalText = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Sending…';

      var payload = {
        type: mode === 'issue' ? 'issue' : 'lake_request',
        email: email,
        message: message,
        website: formValue(form, 'website'),
        id3dhp: (dialogContext && dialogContext.id3dhp) || '',
        reason: mode === 'issue' ? reason : undefined
      };

      if (!payload.id3dhp) {
        payload.lake_name = (dialogContext && dialogContext.name) || '';
        payload.coords = (dialogContext && dialogContext.coords) || '';
      }

      fetch(API_BASE + '/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            submit.disabled = false;
            submit.textContent = originalText;
            errorBox.textContent = result.body.error || 'Something went wrong. Please try again.';
            errorBox.hidden = false;
            return;
          }
          rememberEmail(email);
          renderSuccess(mode, email, reason);
        })
        .catch(function (error) {
          console.error('Feedback request failed:', error);
          submit.disabled = false;
          submit.textContent = originalText;
          errorBox.textContent = 'Something went wrong. Please try again.';
          errorBox.hidden = false;
        });
    }

    function renderSuccess(mode, email, reason) {
      dialogContent.innerHTML = '';
      setDialogLabel('Thanks');
      var label = lakeLabel();
      dialogContent.appendChild(h('span', 'new-lake-success-icon', '✓'));

      if (mode === 'issue') {
        dialogContent.appendChild(h('h3', null, 'Thanks — we’ll take a look.'));
        dialogContent.appendChild(h('p', null, 'Your note about ' + label + ' is with us.'));
      } else {
        dialogContent.appendChild(h('h3', null, "You're on the list."));
        dialogContent.appendChild(
          h('p', null, "We'll email " + email + " when " + label + " is in the shop — usually within a day or two.")
        );
      }

      var close = h('button', 'new-lake-submit', 'Done');
      close.type = 'button';
      close.addEventListener('click', function () {
        dialog.close();
      });
      dialogContent.appendChild(close);

      if (mode === 'issue' && reason === 'wrong_lake') {
        var again = h('p', 'new-lake-switch');
        again.appendChild(document.createTextNode('Want to try another lake? '));
        var search = h('button', 'new-lake-link-btn', 'Search again');
        search.type = 'button';
        search.addEventListener('click', function () {
          dialog.close();
          focusSearch();
        });
        again.appendChild(search);
        dialogContent.appendChild(again);
      }
    }

    function openDialog(mode) {
      dialogContext = {
        id3dhp: (lake && lake.id3dhp) || '',
        name: (lake && lake.name) || typedName || '',
        state: (lake && lake.state) || '',
        county: (lake && lake.county) || '',
        coords: (lake && lake.coords) || ''
      };

      if (!dialog.open) dialog.showModal();
      dialogContent.innerHTML = '<div class="new-lake-loading"><span class="new-lake-spinner"></span><span>Checking our lakes…</span></div>';

      if (mode !== 'request' || !dialogContext.name) {
        renderForm(mode);
        return;
      }

      catalogPromise
        .then(function () {
          var decision = window.WlyLakeCatalog
            ? window.WlyLakeCatalog.find({
                name: dialogContext.name,
                state: dialogContext.state,
                county: dialogContext.county
              })
            : { kind: 'none', matches: [] };

          if (decision.kind === 'exact') renderExisting(decision.matches[0].entry);
          else if (decision.kind === 'possible') renderPossible(decision.matches, mode);
          else renderForm(mode);
        })
        .catch(function () {
          renderForm(mode);
        });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      var target = event.target.closest ? event.target.closest('[data-action="close"]') : null;
      if (target) dialog.close();
    });

    dialog.addEventListener('close', function () {
      dialogContent.innerHTML = '';
      dialogContext = null;
    });

    // ---------- map picker ----------
    (function () {
      var modal = document.getElementById('new-lake-modal');
      var findOnMapBtn = document.getElementById('new-lake-find-on-map');
      var confirmBtn = document.getElementById('new-lake-modal-confirm');
      var cancelBtn = document.getElementById('new-lake-modal-cancel');
      var defaultLat = 42.583491;
      var defaultLon = -83.462872;
      var modalMap = null;
      var modalMarker = null;
      var leafletPromise = null;

      function ensureLeaflet() {
        if (leafletPromise) return leafletPromise;
        leafletPromise = new Promise(function (resolve, reject) {
          if (typeof L !== 'undefined') {
            resolve();
            return;
          }
          var css = document.createElement('link');
          css.rel = 'stylesheet';
          css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
          document.head.appendChild(css);

          var script = document.createElement('script');
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
        return leafletPromise;
      }

      function initMap() {
        if (modalMap) return;
        modalMap = L.map('new-lake-modal-map').setView([defaultLat, defaultLon], 8);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(modalMap);

        setTimeout(function () {
          try {
            modalMap.invalidateSize();
          } catch (error) {
            /* ignore */
          }
        }, 200);

        modalMap.on('click', function (event) {
          placeMarker(event.latlng.lat, event.latlng.lng);
        });

        placeMarker(defaultLat, defaultLon);
      }

      function placeMarker(lat, lon) {
        if (modalMarker) {
          modalMarker.setLatLng([lat, lon]);
        } else {
          modalMarker = L.marker([lat, lon], { draggable: true }).addTo(modalMap);
          modalMarker.on('dragend', function (event) {
            var position = event.target.getLatLng();
            placeMarker(position.lat, position.lng);
          });
        }
        modalMap.setView([lat, lon], 10);
      }

      function openMap() {
        modal.classList.add('is-open');
        ensureLeaflet()
          .then(function () {
            setTimeout(initMap, 80);
          })
          .catch(function (error) {
            console.error('Leaflet load error:', error);
            modal.classList.remove('is-open');
            renderError('The map could not load. Try a lake name instead.');
          });
      }

      function closeMap() {
        modal.classList.remove('is-open');
      }

      findOnMapBtn.addEventListener('click', openMap);
      cancelBtn.addEventListener('click', closeMap);

      confirmBtn.addEventListener('click', function () {
        if (!modalMarker) {
          window.alert('Please place a marker on the map first.');
          return;
        }
        var position = modalMarker.getLatLng();
        closeMap();
        selected = null;
        lake = null;
        typedName = '';
        generateFromPayload({ coords: position.lat.toFixed(6) + ',' + position.lng.toFixed(6) });
      });

      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeMap();
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
